import { FC, ReactNode } from 'react';

import * as ST from './styled';

interface IProps {
    icon: string | ReactNode,
    title?: string,
    content?: string | ReactNode,
}

const InfoBlockItem: FC<IProps> = ({ icon, title, content }) => {

    return (
        <ST.Wrapper>
            {icon}
            <ST.ContentWrapper>
                {title && <ST.Title>{title}</ST.Title>}
                <ST.Content className={'ym-hide-content'}>{content}</ST.Content>
            </ST.ContentWrapper>
        </ST.Wrapper>
    );
};

export default InfoBlockItem;
